import React from 'react';


const TooltipNode = () => {

    const onOpenNewTab = () => {
        window.open('https://trakrefv4.zendesk.com/hc/en-us/sections/28475963039501-Email-Alerts', '_blank').focus();
    };

    return (
        <>
            <div>
                <p>An Email Alert is an email generated by an automated process</p>
                <p>and sent to the designated recipients when a condition is met.</p>
                <br />
                <p>An account can opt into some or all alerts in order to remain informed</p>
                <p>on activity within their account.</p>
                <br />
                <div
                    onClick={onOpenNewTab}
                    style={{
                        gap: "5px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignContent: "center",
                        alignItems: "center",
                        cursor: 'pointer'
                    }}
                >
                    <u
                        style={{
                            fontWeight: "500",
                            letterSpacing: "0.082px",
                            textTransform: "uppercase"
                        }}
                    >
                        View email alerts details and templates
                    </u>
                    <img
                        src='/images/ic_open_link.svg' alt='open_link'
                        style={{
                            width: "12px",
                            height: "12px",
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export default TooltipNode;